import { react2angular } from 'react2angular/index';
import ExternalFeedbackQuestion from './ExternalFeedbackQuestion';

angular
  .module('bb.external')
  .component(
    'bbExternalFeedbackQuestion',
    react2angular(ExternalFeedbackQuestion, ['onChange', 'question', 'index']),
  );
